import React , {Component} from 'react';
import { Row } from 'antd';
import WrappedNormalLoginForm from './login';
import { globalUrlPrefix } from '../utils/const'

export class LoginView extends Component {

    render(){
        let redirectPage = ((this.props.location.state) || {}).from !== undefined ?
                            (this.props.location.state.from)
                            :"/" + globalUrlPrefix + "/dashboard";
        
        let search = ((this.props.location.state || {}).from || {}).search;
        let demoLogin = false;
        if (search != undefined) {
            demoLogin = search.includes("demo=true");
        }

        return(
            <Row className="login-mp">
                    <WrappedNormalLoginForm redirectPage={redirectPage} demoLogin={demoLogin}/>
            </Row>
        )
    }
  }